<div
  class="min-w-72 flex flex-row bg-white rounded-full pt-1 pb-1 pl-2 pr-3 gap-1 items-center justify-between"
>
  <ui-icon
    *ngIf="isRecording"
    name="microphone-filled"
    fill="critical-300"
    size="24"
    m-size="24"
    class="animation-blink"
  />
  <button type="button" (click)="togglePlayPause()">
    <ui-icon
      [hidden]="isRecording || isPlayingRecording"
      name="arrow-right-bold"
      fill="neutrals-900"
      size="24"
      m-size="24"
    />
    <ui-icon
      [hidden]="isRecording || !isPlayingRecording"
      name="pause-circle-filled"
      fill="neutrals-900"
      size="24"
      m-size="24"
    />
  </button>
  <div style="width: 100%" id="waveform"></div>
  <ui-paragraph
    type="p14"
    mobile-type="p14"
    text-color="neutrals-800"
    font-weight="medium"
    class="w-16 text-center"
  >
    {{ formattedRecordingTime }}
  </ui-paragraph>
  <button
    class="ml-2"
    *ngIf="isRecording"
    type="button"
    (click)="stopRecording()"
  >
    <ui-icon
      name="pause-circle-filled"
      size="17"
      m-size="17"
      fill="neutrals-900"
    />
  </button>
</div>
